var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "act_edit",
    d: "M18.8382 1.17216C18.0811 0.41514 17.075 0 16.0054 0C14.9358 0 13.9297 0.41514 13.1727 1.17216L1.98835 12.3565C1.89555 12.4493 1.82229 12.5714 1.7881 12.6984L0.0298614 19.0085C-0.0482827 19.2821 0.0298614 19.5751 0.230106 19.7705C0.376626 19.917 0.57687 20 0.781998 20C0.855258 20 0.923634 19.9902 0.996894 19.9707L7.30703 18.1783C7.57565 18.105 7.78078 17.8901 7.84915 17.6215C7.91753 17.3529 7.84427 17.0696 7.64891 16.8742L3.66845 12.884L12.9432 3.61416L16.3913 7.06227L9.29482 14.1441C8.98713 14.4469 8.98713 14.9451 9.29482 15.2479C9.59763 15.5556 10.0958 15.5556 10.3986 15.2479L18.8382 6.83272C19.5952 6.0757 20.0103 5.0696 20.0103 4.00488C20.0103 2.93529 19.5952 1.92918 18.8382 1.17216ZM5.60739 17.0403L1.9102 18.0904L2.94561 14.3736L5.60739 17.0403ZM17.7344 5.72894L17.4999 5.96337L14.0518 2.51526L14.2814 2.28083C14.7405 1.82173 15.3559 1.56777 16.0054 1.56777C16.655 1.56777 17.2704 1.82173 17.7295 2.28083C18.1886 2.73993 18.4426 3.35531 18.4426 4.00488C18.4426 4.65446 18.1935 5.26496 17.7344 5.72894Z",
    fill: "#1E3799"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActEdit);
export default __webpack_public_path__ + "static/media/act_edit.6b76c6845cacf3b77ff4b1fe0880ad88.svg";
export { ForwardRef as ReactComponent };